import React, { useEffect, useState } from 'react';
import { QuestionRendererProps } from './types';
import { LatexRenderer } from '../../ui/LatexRenderer';
interface Segment {
  text: string;
  id: string;
  isCorrect?: boolean;
  isTappable?: boolean;
  isHighlighted?: boolean;
}
export function TextHighlightRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const config = question.interactiveConfig || {};
  const segments: Segment[] = config.segments || [];
  const [selectedId, setSelectedId] = useState<string | null>(null);
  useEffect(() => {
    // Ready when a selection is made
    onReadyChange?.(selectedId !== null);
  }, [selectedId, onReadyChange]);
  useEffect(() => {
    if (shouldValidate && selectedId) {
      onAnswer(selectedId);
    }
  }, [shouldValidate, selectedId, onAnswer]);
  const handleSegmentClick = (segment: Segment) => {
    if (segment.isTappable === false) return;
    setSelectedId(segment.id);
  };
  return <div className="w-full max-w-3xl mx-auto" data-id="element-1518">
      <div className="bg-white p-6 md:p-8 rounded-xl border-2 border-slate-200 shadow-sm leading-loose text-lg md:text-xl" data-id="element-1519">
        {segments.map((segment, index) => {
        const isSelected = selectedId === segment.id;
        const isTappable = segment.isTappable !== false;
        if (!isTappable) {
          return <span key={segment.id || index} className="text-slate-800" data-id="element-1520">
                <LatexRenderer content={segment.text} data-id="element-1521" />
              </span>;
        }
        return <span key={segment.id || index} onClick={() => handleSegmentClick(segment)} className={`
                inline-block px-1 rounded transition-colors cursor-pointer select-none
                ${isSelected ? 'bg-indigo-600 text-white shadow-sm' : 'hover:bg-indigo-100 text-slate-800 border-b-2 border-transparent hover:border-indigo-200'}
              `} data-id="element-1522">
              <LatexRenderer content={segment.text} data-id="element-1523" />
            </span>;
      })}
      </div>

      <p className="text-center text-slate-400 text-sm mt-6" data-id="element-1524">
        Tik op het juiste stukje tekst
      </p>
    </div>;
}